var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04752 1.50207C6.04752 1.17462 5.78208 0.90918 5.45463 0.90918C5.12719 0.90918 4.86175 1.17462 4.86175 1.50207V4.86175H1.50207C1.17462 4.86175 0.90918 5.12719 0.90918 5.45463C0.90918 5.78208 1.17462 6.04752 1.50207 6.04752H4.86175V9.4072C4.86175 9.73464 5.12719 10.0001 5.45463 10.0001C5.78208 10.0001 6.04752 9.73464 6.04752 9.4072V6.04752H9.4072C9.73464 6.04752 10.0001 5.78208 10.0001 5.45463C10.0001 5.12719 9.73464 4.86175 9.4072 4.86175H6.04752V1.50207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.8528e183718cdcaf65694dff55f0d6a2.svg";
export { ForwardRef as ReactComponent };